import type { CareerLayerApiResponse } from '@/domains/careerLayer/careerLayer.entity';
import type { CareerLayerRepository } from '@/domains/careerLayer/careerLayerData.repository';

/**
 * Use Case para obtener datos de CareerLayer (capa de carrera) desde el repositorio
 * Cumple ISP: Interface Segregation Principle
 * Cumple DIP: Dependency Inversion Principle (depende de abstracción CareerLayerRepository)
 *
 * Responsabilidades:
 * - Obtener datos completos de una carrera específica desde la fuente de datos
 * - Actuar como intermediario entre la capa de dominio y la infraestructura
 */
export class GetCareerLayerUseCase {
  private careerLayerDataRepository: CareerLayerRepository;

  /**
   * Inicializa el UseCase con el repositorio de CareerLayer
   * @param careerLayerDataRepository - Repositorio que implementa la interfaz CareerLayerRepository
   */
  constructor(careerLayerDataRepository: CareerLayerRepository) {
    this.careerLayerDataRepository = careerLayerDataRepository;
  }

  /**
   * Ejecuta la obtención de datos de una carrera específica
   * @param career - Código o nombre de la carrera a consultar
   * @returns Promesa con la respuesta completa de CareerLayer (estructura año > semestre > módulos)
   * @throws Error si falla la comunicación con el repositorio o la carrera no existe
   */
  async execute(career: string): Promise<CareerLayerApiResponse> {
    return await this.careerLayerDataRepository.getCareerLayer(career);
  }
}
